<template>
  <div>
    <b-container fluid>
      <b-row>
        <!-- <b-col cols="12">
          <h3 class="text-center">Add and View Coupons <span class="smh"></span></h3>
        </b-col> -->
        <b-col cols="12">
            <div class="board-wrapper">
                <digit-board class="board-items" title="Total Ambassadors" symbol="" :value="ambassadorsarray[0].overallamb" color="green"></digit-board>
                <digit-board class="board-items" title="Total Signups from Ambs" symbol="" :value="ambassadorsarray[0].overallsignups" color="green"></digit-board>
                <digit-board class="board-items" title="Total Upgrades from Ambs" symbol="" :value="ambassadorsarray[0].overallupgradedusers" color="green"></digit-board>
                <digit-board class="board-items" title="Total Revenues from Ambs" symbol="N" :value="ambassadorsarray[0].overallrevenues" color="green"></digit-board>
            </div>
        </b-col>
        
      </b-row>


      <b-row v-if="ambassadorshowing == 'ambdata'">
        <b-col class="mt-3" style="overflow-x: scroll">
          <h3 class="text-center">Ambassadors Data</h3>
          <!-- <p class="text-center">Click on any title to edit</p> -->
          <div class="text-center list-heads pt-1">
              <p class="head-p">S/N</p>
              <p class="head-p">Name</p>
              <p class="head-p">Email</p>
              <p class="head-p">Phone(WA)</p>
              <p class="head-p">Ref Code</p>
              <p class="head-p">Location</p>
              <p class="head-p">Total Earnings (N)</p>
              <p class="head-p">Total Payouts (N)</p>
              <p class="head-p">Refs Registered</p>
              <p class="head-p">Refs Upgraded</p>
          </div>

          <div v-if="ambassadorsarray[0][this.ambassadorshowing].length > 0">
              <ambassadors-list class="mt-2 maxres" v-for="(ambassador, index) in useambassadorsarray" :sn="index + 1" :ambassador="ambassador" :key="index" :page="pages" :interval='intervalnum'></ambassadors-list>
              <paginater v-if="ambassadorsarray[0][this.ambassadorshowing].length > 0" :intervalnum="intervalnum" :pages="pages" :endss="endss" :endnum="endnum" :datalength="endss" @paginator="newPage" @changeInterval="effectInterval"></paginater>
          </div>
          <div v-else>
              <h3>No ambassador Yet</h3> 
          </div>
          
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import store from "@/store"
import ambassadorsList from '@/components/ambassadorsList';
import Paginater from "@/components/Paginater"
import digitBoard from "@/components/digitBoard"
// import  ckeditor  from "@/js/ckeditorconfig"
// const { ClassicEditor, config } = ckeditor
// import axios from "axios";

export default {
  components: {
      ambassadorsList,
      Paginater,
      digitBoard
  },

  data() {
    return {
        ambassador: this.getForm(),
        reqambassadors : this.getambassador(),
        sending: false,
        sendingreq : false,
        sent : false,
        sentreq : false,
        levels: [0, 1, 2, 3, 4, 5],
        startnum: 0,
        limitnum: this.endss,
        intervalnum: 10,
        endnum: 10,
        btnrange : this.endss,
        pages : 1,
        stockingdata : [{
            data : []
        }],
        dataretrieved : false,
        addresponse : "",
        openambassador : false,
        // editor : ClassicEditor,
        // config : config,
        isCheckingcode : false,
        couponexists : false,
        uploadingfile : false,
        uploadedfile : false,
        uploadmessage : "",
        mtype : "",
        filedir : "",
        ambassadorshowing : "ambdata"
        // datacount : this.partnershipsarray[0].count
    };
  },
  beforeRouteEnter(to, from, next){

    //   let orgname = store.state.loginmaster.details.clearance_organization
        store.dispatch("admin/fetchAmbassadors")
        next();
  },
  created(){
  },
  computed: {
        ...mapState({
            users: (state) => state.admin.allusers,
            details : state => state.loginmaster.details,
            ambdetails : state => state.loginmaster.details.ambassador_details,
            ambassadorsarray : state => state.admin.ambassadorsarray,
            environ : state => state.loginmaster.environ,
            origin : (state) => state.loginmaster.site_origin
        }),
        useambassadorsarray() {
            return this.ambassadorsarray[0][this.ambassadorshowing].slice(this.startnum, this.endnum);
        },
        endss() {
            let end = this.ambassadorsarray[0][this.ambassadorshowing].length;
            return end;
        },
        ranger(){
            let ranger = Math.ceil(this.ambassadorsarray[0][this.ambassadorshowing].length/this.intervalnum)
            return ranger
        },
        chkfields(){
            if(this.sending ||  this.ambassador.acct_name.length <= 0 || this.ambassador.acct_bank.length <= 0 || this.ambassador.acct_type.length <= 0 
                || this.ambassador.acct_number.length <= 0 ){
                return true
            }else{
                return false
            }
        },
        chkfieldsreq(){
            if(this.sendingreq || this.chkthreshold){
                return true
            }else{
                return false
            }
        },
        chkthreshold(){
            if(this.ambassadorsarray[0].balance < 10){
                return true
            }else{
                return false
            }
        }
  },
  methods: {
        ...mapActions("dashboard", ["updateAmbacct","fetchAmbstat","requestambassador"]),
        getForm() {
            return {
                acct_type : "",
                acct_name : "",
                acct_bank : "",
                acct_number : "",
                email : ""
            };
        },
        getambassador(){
            return {
                amount : 0
            }
        },
        uppercasename(){
            this.ambassador.acct_name = this.ambassador.acct_name.charAt(0).toUpperCase() + this.ambassador.acct_name.slice(1);
        },
        requestambassador(){
            this.sendingreq = true;

            this.reqpayouts.email = this.ambdetails.ambassador_email
            this.reqpayouts.first_name = this.ambdetails.ambassador_first_name
            this.reqpayouts.last_name = this.ambdetails.ambassador_last_name

            return this.requestPayout(this.reqpayouts).then(() => {
                this.sendingreq = false;
                this.sentreq = true

                this.fetchAmbstat();
            });
        },
        updateambacct() {
            this.sending = true;
            this.ambassador.email = this.ambdetails.ambassador_email
            
            return this.updateAmbacct(this.ambassador).then(() => {
                this.sending = false;
                this.sent = true

                this.fetchAmbstat();
            });
        },
        newPage(page){
            // alert(page)
            this.pages = page
            let newend = this.intervalnum * page;

            if (newend < this.endss) {
                this.endnum = newend;
                this.startnum = newend - this.intervalnum ;
            } else {
                this.endnum = this.endss;
                this.startnum = newend - this.intervalnum ;
            }

        },
        effectInterval(newinterval){
            this.intervalnum = newinterval
            this.pages = 1
            this.newPage(this.pages)
        },

        checkCouponcode(){
            this.ambassador.couponcode = this.ambassador.couponcode.toUpperCase()

            if(this.ambassador.couponcode.length > 0){
                this.isCheckingcode = true
            }else{
                this.isCheckingcode = false
            }

            // alert(this.ambassador.couponcode)

            return this.checkCoupon(this.ambassador.couponcode).then((response) => {
                this.couponexists = response
                // console.log(response)
            })
        },
        stopproceed(){
            this.sending = false
        },
  },
  
};
</script>

<style scoped>
.list-heads {
    background-color: #00984A;
    color: white;
    border-radius: 5px 5px;
    font-weight: bold;
    display: flex;
    flex-flow: row nowrap;
}
.head-p{
    width: 10%;
    padding: 2px;
}
.flex-input-parent{
    display: flex;
}
.left-flex-child{
    width: 95%;
}
.right-flex-child{
    width: 5%;
}
.hidden{
    display: none
}
.full-width-child{
    width : 100%
}
.font-green{
    color: green;
}
.errtxt{
    color: red;
}
.board-wrapper{
    display: flex;
    flex-flow : row wrap;
    justify-content: flex-start;
}
.board-items{
    width : 30%;
    margin: 3px;
}


@media screen and (max-width: 999px) {
     .head-p{
        font-size: 0.6rem
    }
    .page-buttons{
        width: 25px;
        height: 25px;
        padding: 0px 0px 0px 5px ;
    }
}
</style>
